module.exports = __webpack_public_path__ + "static/media/29ADMSPC6.062b5d98.jpg";